//获取两位小数规范
function getDecimal(num) {
  let decimal = num.toString().match(/^\d*(\.?\d{0,2})/g)
    ? num === "00"
      ? "0"
      : num.toString().match(/^\d*(\.?\d{0,2})/g)[0]
    : "";
  return decimal;
}

//获取4位小数规范
function getFourDecimal(num) {
  let decimal = num.toString().match(/^\d*(\.?\d{0,4})/g)
    ? num === "00"
      ? "0"
      : num.toString().match(/^\d*(\.?\d{0,4})/g)[0]
    : "";
  return decimal;
}

/* 限制金额为2位小数（包含负数） */
function inputAllTwoDecimal(val) {
  let price = val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)
    ? val === "00"
      ? "0"
      : val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)[0]
    : "";
  return price;
}

//获取整数规范
function getInteger(num) {
  let integer = num.toString().match(/^[1-9]\d*/)
    ? num.toString().match(/^[1-9]\d*/)[0]
    : num === "0"
    ? "0"
    : "";
  return integer;
}

function formatTimeToDate(time) {
  let date = new Date(time);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  let detailDate = date.getDate();
  detailDate = detailDate > 9 ? detailDate : "0" + detailDate;
  return `${year}-${month}-${detailDate}`;
}

function formaTimeToSecond(time) {
  let date = new Date(time);
  let hour = date.getHours();
  hour = hour > 9 ? hour : "0" + hour;
  let minute = date.getMinutes();
  minute = minute > 9 ? minute : "0" + minute;
  let second = date.getSeconds();
  second = second > 9 ? second : "0" + second;
  return `${hour}:${minute}:${second}`;
}

function formaTimeToMinute(time) {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let minute = date.getMinutes()
  minute = minute > 9 ? minute : '0' + minute
  return `${year}-${month}-${detailDate}  ${hour}:${minute}`
}

function formaTimeToAllSecond(time) {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let detailDate = date.getDate()
  detailDate = detailDate > 9 ? detailDate : '0' + detailDate
  let hour = date.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let minute = date.getMinutes()
  minute = minute > 9 ? minute : '0' + minute
  let second = date.getSeconds();
  second = second > 9 ? second : "0" + second;
  return `${year}-${month}-${detailDate}  ${hour}:${minute}:${second}`
}

function handleGetRequestParams(params) {
  let url = ''
  for (let key in params) {
    let value = (params[key] !== undefined && params[key] !== null) ? params[key] : '';
    url += `&${key}=${encodeURIComponent(value)}`
  }
  return url.substring(1)
}

/* 把url转为[blob]文件格式(包括图片,pdf,word,excel)下载，
第一个参数是文件名称，第二个参数是文件的路径 */
function downLoadFile(fileName, data) {
  if (!data) {
    return
  }
  fetch(data).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
    let url = window.URL.createObjectURL(blob)
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  })
}

/**
 * @desc 四舍五入保留2位小数（若第二位小数为0，则保留一位小数）
 */
function keepTwoDecimal(num) {
  let result = parseFloat(num);
  if (isNaN(result)) {
    // alert('传递参数错误，请检查！');
    return false;
  }
  result = Math.round(num * 100) / 100;
  return result;
}

/** 
 * @desc 数字每千位加逗号
 */
function commafy(num) {
  return num && num.toString()
    .replace(/\d+/, function (s) {
      return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    })
}


/* 防抖 */
function debounce(fn, delay) {
  let timer = null
  return function () {
    if (timer) {
      clearTimeout(timer)
      console.log('拦截')
    }
    timer = setTimeout(() => {
      console.log('发送')

      fn.apply(this, arguments)
      timer = null
    }, delay)
  }
}

/* 修改网页标题 */
const modifyNetTitle = function (netTitle, logoUlr) {
  let logo,
    title
  // if (logoUlr) {
  //   logo = logoUlr
  // } else {
  //   logo = 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
  // }
  if (netTitle) {
    title = `${netTitle}-水晶后台管理系统`
  } else {
    title = '水晶后台管理系统'
  }
  // let link = `<link rel="icon" href="${logo}">`
  // let tempNode = document.createElement("div")
  // tempNode.innerHTML = link
  // document.querySelector("head").append(tempNode.firstChild)
  document.querySelector('title').innerHTML = title
}

export { getDecimal, getFourDecimal, inputAllTwoDecimal, getInteger, formatTimeToDate, formaTimeToMinute, formaTimeToSecond, formaTimeToAllSecond, handleGetRequestParams, downLoadFile, keepTwoDecimal, commafy, debounce, modifyNetTitle };
